import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PlayCircle } from "lucide-react";
import { useApi } from "../../lib/api";

const useClock = () => {
  const [t, setT] = useState(new Date());
  useEffect(() => {
    const i = setInterval(() => setT(new Date()), 1000);
    return () => clearInterval(i);
  }, []);
  return t.toLocaleTimeString("en-GB", { timeZone: "Africa/Accra" });
};

const SLUG = { peace: "peace-fm", utv: "utv", okay: "okay-fm", neat: "neat-fm", hello: "hello-fm" };

export const WhatsOn = () => {
  const { data } = useApi("/public/whats-on");
  const clock = useClock();
  return (
    <div className="panel p-5 backdrop-blur-xl bg-white/90" data-testid="whats-on-widget">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2"><span className="live-dot" /><span className="eyebrow">What's on now</span></div>
        <span className="font-data text-sm text-ink" data-testid="ghana-clock">{clock} GMT</span>
      </div>
      <div className="divide-y divide-[color:var(--line)]">
        {(data?.stations || []).map((s) => (
          <div key={s.key} className="py-3 flex items-center gap-3" data-testid={`whats-on-${s.key}`}>
            <img src={s.logo} alt={`${s.name} logo`} className="w-10 h-10 rounded-full object-cover bg-white border border-[color:var(--line)]" />
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-x-2">
                <Link to={`/entities/${SLUG[s.key]}`} className="text-sm font-semibold text-ink hover:text-brand-green" data-testid={`whats-on-link-${s.key}`}>{s.name}</Link>
                <span className="font-data text-[10px] text-slate-500">{s.freq}</span>
                {s.wired && <span className="pill pill-gold">Live wired</span>}
              </div>
              <div className="text-xs text-slate-300 truncate">{s.now?.title || "Music & continuity"} {s.now && <span className="text-slate-500">· {s.now.host}</span>}</div>
              {s.now && <div className="font-data text-[10px] text-slate-500 truncate">{s.now.start}–{s.now.end} · Next: {s.next?.title || "—"}</div>}
            </div>
            <Link to={`/entities/${SLUG[s.key]}`} className="text-slate-400 hover:text-[color:var(--gold)] transition-colors" data-testid={`listen-${s.key}`} aria-label={`Listen to ${s.name} live`}>
              <PlayCircle size={26} />
            </Link>
          </div>
        ))}
      </div>
      <p className="text-[11px] text-slate-500 mt-3">{data?.note}</p>
    </div>
  );
};
